import { render, staticRenderFns } from "./EditImg.vue?vue&type=template&id=30d032da&scoped=true"
import script from "./EditImg.vue?vue&type=script&lang=js"
export * from "./EditImg.vue?vue&type=script&lang=js"
import style0 from "../assets/css/sign.css?vue&type=style&index=0&id=30d032da&prod&scoped=true&lang=css&external"
import style1 from "./EditImg.vue?vue&type=style&index=1&id=30d032da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d032da",
  null
  
)

export default component.exports